import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";

import Layout from "./components/layout";
import Dashboard from "./pages/dashboard";
import Purchase from "./pages/purchase";
import Usages from "./pages/usages";
import NgnUsages from "./pages/ngn-usages";
import Withdraws from "./pages/withdraws";
import Payment from "./pages/payment";
import Settings from "./pages/settings";
import ChangePassword from "./pages/settings/change-password";
import ChangeAddress from "./pages/settings/change-address";
import ChangeIdentity from "./pages/settings/change-identity";
import Request from "./pages/request";
import RequestTd from "./pages/request-td";
import RequestFd from "./pages/request-fd";
import Ngn from "./pages/ngn-file/ngn";
import Result from "./pages/purchase/result";
import SignUp from "./pages/signup";
import SignUpPayment from "./pages/signup/payment";
import SignUpPurchase from "./pages/signup/purchase";
import SignUpUploadImage from "./pages/signup/upload-image";
import NgnSignUpSelectline from "./pages/signup/ngn/selectLine";
import Tickets from "./pages/ticket/tickets";
import RegisterTicket from "./pages/ticket/register-Ticket";
import Services from "./pages/services/services";
import PurchaseChannel from "./pages/purchase/ngn-channel";
import Payments from "./pages/payments";
import RegisterBankReceipt from "./pages/payment/register-bank-receipt";
import Withdraw from "./pages/withdraw";
import SpeedTest from "./pages/speedTest/speedTest";
import SpeedTestResult from "./pages/speedTest/speedTestResult";
import LandingPayment from "./pages/landing-page";
import PayPage from "./pages/Pay";
import { AuthContextProvider } from "./components/auth-context";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        path="/"
        element={
          <AuthContextProvider>
            <Layout />
          </AuthContextProvider>
        }
      >
        <Route index element={<Dashboard />} handle={{ title: "داشبورد" }} />
        <Route
          path="/pay/:lineId"
          element={<PayPage />}
          handle={{ title: "پرداخت" }}
        />
        <Route
          path="/landing-payment/:receiptId"
          element={<LandingPayment />}
          handle={{ title: "درگاه پرداخت" }}
        />
        <Route path="purchase">
          <Route
            path=":type"
            element={<Purchase />}
            handle={{ title: "خرید سرویس" }}
          />
          <Route
            path="ngnChannel"
            element={<PurchaseChannel />}
            handle={{ title: "خرید NGN کانال" }}
          />
          <Route
            path="result/:receiptId"
            element={<Result />}
            handle={{ title: "نتیجه خرید" }}
          />
        </Route>
        <Route
          path="payment/:receiptId"
          element={<Payment />}
          handle={{ title: "پرداخت" }}
        />
        <Route
          path="usages"
          element={<Usages />}
          handle={{ title: "کارکرد ADSL" }}
        />
        <Route
          path="ngnUsages"
          element={<NgnUsages />}
          handle={{ title: "کارکرد NGN" }}
        />
        <Route
          path="withdraws"
          element={<Withdraws />}
          handle={{ title: "لیست خریدها" }}
        />
        <Route
          path="withdraw-detail/:id"
          element={<Withdraw />}
          handle={{ title: "جزئیات خرید" }}
        />
        <Route
          path="payments"
          element={<Payments />}
          handle={{ title: "پرداخت ها" }}
        />
        <Route
          path="speedTest"
          element={<SpeedTest />}
          handle={{ title: "تست سرعت" }}
        />
        <Route
          path="speedTest/result"
          element={<SpeedTestResult />}
          handle={{ title: "نتیجه تست سرعت" }}
        />
        <Route
          path="registerTicket"
          element={<RegisterTicket />}
          handle={{ title: "ثبت تیکت" }}
        />
        <Route
          path="tickets"
          element={<Tickets />}
          handle={{ title: "تیکت‌ ها" }}
        />
        <Route
          path="services"
          element={<Services />}
          handle={{ title: "سرویس‌ ها" }}
        />
        <Route
          path="registerBankReceipt"
          element={<RegisterBankReceipt />}
          handle={{ title: "ثبت فیش بانکی" }}
        />
        <Route path="request">
          <Route
            path="adsl"
            element={<Request />}
            handle={{ title: "درخواست سرویس ADSL" }}
          />
          <Route
            path="td"
            element={<RequestTd />}
            handle={{ title: "درخواست سرویس TD-LTE" }}
          />
          <Route
            path="fd"
            element={<RequestFd />}
            handle={{ title: "درخواست سرویس FD-LTE" }}
          />
          <Route
            path="ngn"
            element={<Ngn />}
            handle={{ title: "درخواست سرویس NGN" }}
          />
        </Route>
        <Route path="settings" handle={{ title: "تنظیمات" }}>
          <Route index element={<Settings />} handle={{ title: "تنظیمات" }} />
          <Route
            path="password"
            element={<ChangePassword />}
            handle={{ title: "تغییر رمز عبور" }}
          />
          <Route
            path="address"
            element={<ChangeAddress />}
            handle={{ title: "تغییر آدرس" }}
          />
          <Route
            path="identity"
            element={<ChangeIdentity />}
            handle={{ title: "تغییر مشخصات هویتی" }}
          />
        </Route>
      </Route>
      <Route path="/signup">
        <Route
          index
          element={<SignUp medium={1} />}
          handle={{ title: "ثبت‌ نام TD-LTE" }}
        />
        <Route
          path="Adsl"
          element={<SignUp medium={0} />}
          handle={{ title: "ثبت‌ نام ADSL" }}
        />
        <Route
          path="Tdlte"
          element={<SignUp medium={1} />}
          handle={{ title: "ثبت‌ نام TD-LTE" }}
        />
        <Route
          path="Fdlte"
          element={<SignUp medium={3} />}
          handle={{ title: "ثبت‌ نام FD-LTE" }}
        />
        <Route
          path="uploadImage"
          element={<SignUpUploadImage />}
          handle={{ title: "آپلود تصویر" }}
        />
        <Route
          path="purchase"
          element={<SignUpPurchase />}
          handle={{ title: "خرید اولیه" }}
        />
        <Route
          path="payment/:receiptId"
          element={<SignUpPayment />}
          handle={{ title: "پرداخت ثبت‌ نام" }}
        />
        <Route path="ngn">
          <Route
            index
            element={<SignUp medium={2} />}
            handle={{ title: "ثبت‌ نام NGN" }}
          />
          <Route
            path="uploadImage"
            element={<SignUpUploadImage />}
            handle={{ title: "آپلود تصویر NGN" }}
          />
          <Route
            path="selectLine"
            element={<NgnSignUpSelectline />}
            handle={{ title: "انتخاب خط NGN" }}
          />
          <Route
            path="purchase"
            element={<SignUpPurchase />}
            handle={{ title: "خرید NGN" }}
          />
          <Route
            path="payment/:receiptId"
            element={<SignUpPayment />}
            handle={{ title: "پرداخت NGN" }}
          />
        </Route>
      </Route>
    </>
  )
);

export default router;
